module.exports = __webpack_public_path__ + "img/ppp-cover.efb5ef59.png";